import { render } from "./GuessListItem.vue?vue&type=template&id=5e908536&scoped=true&ts=true"
import script from "./GuessListItem.vue?vue&type=script&lang=ts"
export * from "./GuessListItem.vue?vue&type=script&lang=ts"

import "./GuessListItem.vue?vue&type=style&index=0&id=5e908536&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e908536"]])

export default __exports__